import { InjectionToken } from "@angular/core";

export const ILOADING_SPINNER = new InjectionToken<ILoadingSpinnerService>(
  "loadingSpinnerService"
);

export interface ILoadingSpinnerService {
  reveal();
  hide();
  setProgress(progress: number);
  showSpin();
  //showSpinWithCounting();
}